import { useActiveOrganization } from "./auth-client";

export interface DemoScope {
  provincia: "FG";
  comune: "Foggia";
}

export function demoScopeForOrganization(organization: unknown): DemoScope | null {
  if (!organization || typeof organization !== "object" || !("slug" in organization) ||
      organization.slug !== "demo-foggia" || !("metadata" in organization)) return null;
  let metadata: unknown = organization.metadata;
  if (typeof metadata === "string") {
    try { metadata = JSON.parse(metadata); } catch { return null; }
  }
  if (!metadata || typeof metadata !== "object" || !("demo" in metadata)) return null;
  const demo = metadata.demo;
  if (!demo || typeof demo !== "object" || !("provincia" in demo) || !("comune" in demo)) return null;
  if (demo.provincia !== "FG" || typeof demo.comune !== "string" || demo.comune.trim() !== "Foggia") return null;
  return { provincia: "FG", comune: "Foggia" };
}

export function useDemoScope(): DemoScope | null {
  const { data: organization } = useActiveOrganization();
  return demoScopeForOrganization(organization);
}
